import React from "react";
import {createPortal} from "react-dom";
import TopNotificationsApi from "../api/topNotificationsApi";
import cookies from "../cookies";
import SubscribeButton from "../subscriptions/handler";
import {setCookie} from "../base/cookieHelper";

function Layer(props) {

    const icon = props.layer.icon || 'mail';

    return(
        <React.Fragment>
            <div className={'top-promo__wrapper'}>
                <div className={`top-promo__icon top-promo__icon--${icon}`}/>
                <p className="top-promo__text" >
                    <span dangerouslySetInnerHTML={{__html: props.layer.left_text}}/>
                        <span className="top-promo__vertical-line show-for-medium"/>
                    {props.layer.subscribe ?
                        <SubscribeButton design={'top_notification'} text={props.layer.right_text} formType={'top_notification'}/>
                        :
                        <a href={props.layer.link} className="top-promo__link"
                           target={props.layer.target_blank ? '_blank' : ''} rel={props.layer.rel}>
                            <span dangerouslySetInnerHTML={{__html: props.layer.right_text}}/>
                            <span className="top-promo__icon top-promo__icon--arrow"/>
                        </a>
                    }
                </p>
            </div>
            <div className="top-promo__icon top-promo__icon--close" onClick={props.onClose}/>
        </React.Fragment>
    )

}

const layerContainer = document.getElementById("top-layer-after");

class LayerPortal extends React.Component {

    state = {
        layer: null,
        isOpened: false
    };

    componentDidMount() {
        this.loadLayers();
    }

    componentWillUnmount() {
        if (this.portalElement)
            layerContainer.removeChild(this.portalElement);
    }

    loadLayers = () => {
        let path = window.location.pathname;
        let _this = this;
        TopNotificationsApi.getLayers(path).then((response) => {
            if (response.top_notification) {
                _this.setState({layer: response.top_notification}, () => {
                    if (response.top_notification && response.top_notification.subscribe && this.isSubscribeCookie()) {
                        _this.closeLayer();
                    } else {
                        _this.renderLayer();
                    }
                });
            }
        }).catch(error => {
            console.log(error);
        });
    };

    isSubscribeCookie = () => {
        let is_sub = cookies.getCookieValue('hra_sub');
        return is_sub && is_sub === 'true'
    };

    renderLayer = () => {
        if (!this.state.layer)
           return null;

        const classNames = `top-promo top-promo--${(this.state.layer.color || 'light-blue')}`;

        let p = document.createElement('div');
        if (this.state.layer.subscribe){
            p.id = 'top-subscribe';
        }
        p.className = classNames;
        layerContainer.appendChild(p);
        this.portalElement = p;

        this.setState({isOpened: true});
    };

    closeLayer = () => {
        setCookie('hr_lay',  {closed: true});
        if (!this.portalElement) { return; }
        this.setState({isOpened: false}, () => {
            layerContainer.removeChild(this.portalElement);
            this.portalElement = null;
        });
    };


    render () {
        if (!this.state.layer || !this.state.isOpened || !this.portalElement) {
            return null;
        }

        return createPortal(<Layer onClose={this.closeLayer} layer={this.state.layer}/>, this.portalElement);
    }
}


export default LayerPortal;
